import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

export class FieldBlock extends Component {
  render() {
    const xsSize = this.props.xsSize || 0;
    const mdSize = this.props.mdSize || 0;
    const smSize = this.props.smSize || 0;
    const lgSize = this.props.lgSize || 0;
    const id = this.props.id || 'keyId';
    let divClassName = this.props.formGroup === undefined ? 'form-group' : '';
    if (this.props.hidden) {
      divClassName = 'form-group hidden';
    }
    return (
    <Row key={'row_' + id} className={this.props.rowClass}>
      <Col xs={xsSize} md={mdSize} sm={smSize} lg={lgSize} className={divClassName} key={'col_' + id}>
        { this.props.children || null }
      </Col>
    </Row>);
  }
}

FieldBlock.propTypes = {
  id: PropTypes.string,
  xsSize: PropTypes.number,
  mdSize: PropTypes.number,
  smSize: PropTypes.number,
  lgSize: PropTypes.number,
  children: PropTypes.element,
  hidden: PropTypes.bool,
  formGroup: PropTypes.bool,
  rowClass: PropTypes.string
};
